import React from "react";

export type Tabs =
  | "env"
  | "repository"
  | "devbox"
  | "preferences"
  | "experiments";

const Context = React.createContext<{
  visible: boolean;
  setVisibility: (value: boolean) => void;
  activeTab: Tabs;
  setActiveTab: (value: Tabs) => void;
}>({
  visible: false,
  setVisibility: () => {},
  activeTab: "repository",
  setActiveTab: () => {},
});

export const SettingsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [visible, setVisibility] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<Tabs>("preferences");

  return (
    <Context.Provider
      value={{
        visible,
        setVisibility: (value) => setVisibility(value),
        activeTab,
        setActiveTab,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useProjectSettingsContext = () => React.useContext(Context);
